import React from 'react'

import { WrapperCenter } from './styles'

import LoadingIcon from '../icons/LoadingIcon'

export default function LoadingFill(props) {
  return (
    <WrapperCenter>
      <LoadingIcon />
    </WrapperCenter>
  )
}
